/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CustomCheckList } from "@components/CustomCheckList/CustomCheckList";
import { useEffect, useState } from "react";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import { ChecklistDocuments } from "@interfaces/catalogs";

const DEFAULT_CHECKLIST: ChecklistDocuments = [
  {
    title: "De la empresa",
    tooltip: "",
    documents: [
      "Acta constitutiva y sus adicionales",
      "Comprobante de domicilio",
      "Información bancaria y últimos 3 estados de cuenta",
    ],
  },
  {
    title: "Del Representante Legal",
    tooltip: "",
    documents: [
      "Constancia de situación fiscal",
      "Identificación y validación de identidad",
      "Comprobante de domicilio",
      "FIEL para firma de contrato",
    ],
  },
  {
    title: "Del aval y accionista mayoritario",
    tooltip: "",
    documents: [
      "Comprobante de domicilio",
      "Información bancaria y último estado de cuenta",
      "Constancia de situación fiscal",
      "Identificación y validación de identidad"
    ],
  },
  {
    title: "Del propietario real",
    tooltip: "",
    documents: [
      "Constancia de situación fiscal",
      "Identificación oficial vigente (INE, Pasaporte,FM2)",
      "Comprobante de domicilio",
    ],
  },
];

const CheckListTest = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [checklist, setChecklist] = useState<ChecklistDocuments>([]);
  const [name, setName] = useState("");

  useEffect(() => {
    const name = localStorage.getItem("name") || "Usuario";
    setName(name);
    setChecklist(DEFAULT_CHECKLIST);
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8}>
        <InactivityHandler />
        <Box textAlign={"center"} mx={4}>
          <Typography
            mt={4}
            mb={2}
            textAlign={"center"}
            variant={isMobileOrTablet ? "h4" : "h3"}
            fontWeight={600}
            color={theme?.palette?.primary?.dark}
          >
            ¡Hola {name}!
          </Typography>
          <Typography
            mb={3}
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.main}
            fontWeight={600}
          >
            Ahora completa el expediente digital.
          </Typography>
          <Typography
            mb={3}
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
          >
            Conforme avances, deberás cargar los siguientes documentos, si no los tienes a la mano puedes guardar tu
            avance y completarlo después
          </Typography>
          <>
            <Box display={"flex"} flexDirection={"column"} gap={2} my={3}>
              {checklist.map((item) => (
                <CustomCheckList
                  key={item.title}
                  id={item.title}
                  title={item.title}
                  tooltip={item.tooltip}
                  items={item.documents}
                />
              ))}
            </Box>
          </>
        </Box>
      </Grid>
      {isMobileOrTablet == false && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default CheckListTest;
